import { devMode } from "@src/env";
import KenBurnsElement from "ken-burns-carousel/dist/element";
import { useEffect } from "react";

import { CurrentTrack } from "@src/components/CurrentTrack";
import { Debug } from "@src/components/Debug";
import { ErrorMessage } from "@src/components/ErrorMessage";
import { NextTrack } from "@src/components/NextTrack";
import { OfflineModeIndicator } from "@src/components/OfflineModeIndicator";
import { PlayPause } from "@src/components/PlayPause";
import { SocialMedia } from "@src/components/SocialMedia";
import { ValidRender } from "@src/components/ValidRender";

import { usePlayer } from "@src/hooks/usePlayer";

import { exchangeMessage } from "@src/utils/serviceWorker/exchangeMessage";
import { shuffleArray } from "@src/utils/shuffleArray";

import "./style.less";

customElements.define("ken-burns-carousel", KenBurnsElement);

const images = shuffleArray(
  Array.from(
    { length: 17 },
    (_, i) => `/canopy/img_${String(i + 1).padStart(2, "0")}.jpg`,
  ),
);

export function CanopyPlayer() {
  const { radio } = usePlayer(false);

  useEffect(() => {
    if (!radio?.name) return;
    exchangeMessage({
      idRadio: radio.name,
      type: "ADD_TO_CACHE",
      payload: {
        cacheName: "assets",
        urls: images,
      },
    }).then(() => {
      console.log("[ADD_TO_CACHE] assets precaching complete:", images);
    });
  }, [radio?.name]);

  if (!radio) {
    return <></>;
  }

  return (
    <ValidRender>
      <div className="CanopyPlayer-page">
        <main>
          <ken-burns-carousel
            images={images}
            fade-duration={2500}
            slide-duration={8000}
          />
          <OfflineModeIndicator radio={radio} />
          <SocialMedia />
          <ErrorMessage />
          {devMode && <Debug radio={radio} />}
        </main>
        <footer>
          <span className="logged_in_as">Rádio Canopy By Hilton</span>
          <PlayPause color="#fff" fontSize="4.5em" size={50} shadow={false} />
          <CurrentTrack />
          <NextTrack />
        </footer>
      </div>
    </ValidRender>
  );
}
